import { getGatsbyImageData } from "gatsby-source-sanity"
import BlockContent from "@sanity/block-content-to-react"
import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { SanityRawText } from "./SanityTypes"
import { constants } from "../constants/constants"
import getYouTubeId from 'get-youtube-id'
import { Blockquote } from "@blueprintjs/core"
const { SANITY_DATASET, SANITY_PROJECTID } = constants
const dataset = SANITY_DATASET
const projectId = SANITY_PROJECTID


const BlockRenderer = (props) => {
  const {style = 'normal'} = props.node

  if (/^h\d/.test(style)) {
    let headerId = ''
      if(typeof props.children[0] == "string"){
        headerId = props.children[0].replace(/\W/g, '').toLowerCase()
      } else if(typeof props.children[1] == "string"){
        headerId = props.children[1].replace(/\W/g, '').toLowerCase()
      } else if(typeof props.node.children[0] == "string"){
        headerId = props.node.children[0].replace(/\W/g, '').toLowerCase()
      } else if(typeof props.node.children[1] == "string"){
        headerId = props.node.children[1].replace(/\W/g, '').toLowerCase()
      } 
    return React.createElement(style, {id: `${headerId}`}, props.children)
  }

  if (style === 'blockquote') {
    return <blockquote>- {props.children}</blockquote>
  }

  // Fall back to default handling
  return BlockContent.defaultSerializers.types.block(props)
}

const Figure = ({ node }) => {
  const fluidProps = getGatsbyImageData(
    node?.image?.asset?._id,
    {},
    { dataset, projectId }
  )
  return (
    <figure>
      {fluidProps && <GatsbyImage image={fluidProps} alt={node.altText} />}
    </figure>
  )
}

const CTAButton = ({ node }) => {
  const {
    buttonLink,
    buttonText,
    mainText,
    primaryColor,
    secondaryColor,
  } = node
  return (
    <div
      className="cta-container"
      style={{ border: `1px solid ${primaryColor}`, borderRadius: 5 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h2 className="main-text" style={{ color: primaryColor }}>
          {mainText}
        </h2>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <a
          onMouseOver={props => {
            props.currentTarget.style.background = secondaryColor
            props.currentTarget.style.color = primaryColor
          }}
          onMouseLeave={props => {
            props.currentTarget.style.background = primaryColor
            props.currentTarget.style.color = secondaryColor
          }}
          style={{
            background: primaryColor,
            color: secondaryColor,
            textAlign: "center",
            padding: "10px 40px",
            borderRadius: 10,
            border: `1px solid ${primaryColor}`,
          }}
          rel="noreferrer noopener"
          target="_blank"
          href={buttonLink}
        >
          {buttonText}
        </a>
      </div>
    </div>
  )
}
export const defaultSerializers = {
  marks: {
    em: props => <i>{props.children}</i>, 
    strong: props => <strong>{props.children}</strong>,
    code: props => (
      <code dangerouslySetInnerHTML={{ __html: props.children }} />
    ),
    color: props => (
      <span style={{ color: props.mark.hex }}>{props.children}</span>
    ),
    link: ({ mark, children }) => {
      return mark.href?.includes("climatecheck.com") ? (
        <Link
          to={
            mark.href?.substring(mark.href?.indexOf("climatecheck.com") + 16) ||
            "/"
          }
        >
          {children[0]}
        </Link>
      ) : (
        <a href={mark.href} target="_blank">{children[0]}</a>
      )
    },
    scrollAnchor: props => {
      const ref = props.mark.href.replace(/\W/g, '').toLowerCase()
      return (<a onClick={() =>{
        let view = document.getElementById(ref)
        view.scrollIntoView()
      }}>{props.children[0]}</a>)
    }
  },
  types: {
    block: BlockRenderer,
    code: props => (
      <pre data-language={props.node.language}>
        <props.node.code>{props.node.code}</props.node.code>
      </pre>
    ),
    reference: ({ node }) => <div>{node.reference}</div>,
    customImage: Figure,
    ctaButton: CTAButton,

    video: props => {
      return(
        <div style={{display:"flex", justifyContent:"center"}}>
          <iframe loading="lazy" width="560" height="315" src={`https://www.youtube.com/embed/${getYouTubeId(props.node.url)}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        
    )}
  },
}

type Props = {
  blocks: SanityRawText[] | SanityRawText
  serializers?
  className?: string
}

export const BaseBlockContent2: React.FC<Props> = ({
  blocks,
  serializers,
  className,
}) => {
  const serializersDict = serializers || defaultSerializers
  return (
    <BlockContent
      serializers={serializersDict}
      blocks={blocks}
      className={className}
    />
  )
}